import { data } from "jquery";
import {} from "./IStatsController";
import {} from "../gen/adprovisioning";
export class ExampleStatsController {
    getImpressionStatsForSlotPerIsoCountry(slotId, from, to) {
        throw new Error("Method not implemented.");
    }
    getImpressionStatsForBookingPerIsoCountry(bookingId, from, to) {
        throw new Error("Method not implemented.");
    }
    getSlotImpressionDurations(slotId, from, to, groupingInterval) {
        throw new Error("Method not implemented.");
    }
    getImpressionStatsForSlot(slotId, from, to, groupingInterval) {
        throw new Error("Method not implemented.");
    }
    getImpressionStatsForBooking(bookingId, from, to, groupingInterval) {
        throw new Error("Method not implemented.");
    }
    getTotalsForBooking(bookingId) {
        throw new Error("Method not implemented.");
    }
    getTotalEarningForBooking(bookingId) {
        throw new Error("Method not implemented.");
    }
    dataPointsToSimulare = 1000;
    /**
     * This function builds a map of timestamp to value raw data for presentation.
     * @param from
     * @param to
     * @param valueRange An array of candidate values to pick from
     * @returns
     */
    buildRandomIntervalMap(from, to, valueRange) {
        let result = new Map();
        let timeIntervalMilis = to.getTime() - from.getTime();
        for (let i = 0; i < this.dataPointsToSimulare; i++) {
            let thisTimestamp = Math.round(Math.random() * timeIntervalMilis);
            let thisValue = valueRange[Math.round(Math.random() * (valueRange.length - 1))];
            result.set(new Date(thisTimestamp), thisValue);
        }
        return result;
    }
    getBookingImpressionDurations(bookingId, from, to, groupingInterval) {
        throw new Error("Method not implemented.");
    }
    async getDailyEarnings(bookingId, from, to) {
        // let valueRange: number[] = [];
        // for(let i = 0; i < this.dataPointsToSimulare; i++) {
        //     valueRange.push(Math.random() * 10000);
        // }
        // let rawData: Map<Date, number> = this.buildRandomIntervalMap(from, to, valueRange)
        let result = new Map();
        for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
            result.set(new Date(d), Math.random() * 10000);
        }
        return result;
    }
}
